import { useState } from "react";
import { useTranslation } from "react-i18next";
import HeroServiceDesk from "./components/HeroServiceDesk";
import DashboardSD from "./components/DashboardSD";
import FeaturesServiceDesk from "./components/FeaturesServiceDesk";
import QuoteModal from "@/components/feature/QuoteModal";
import InfoModal from "@/components/feature/InfoModal";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import Navbar from "@/pages/home/components/Navbar";
import InternalCTASection from "@/components/feature/InternalCTASection";
import LandingFooter from "@/components/feature/LandingFooter";
import LanguageTransitionWrapper from "@/components/feature/LanguageTransitionWrapper";

export default function ServiceDeskPage() {
  const { t } = useTranslation("common");
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quoteService, setQuoteService] = useState<string | undefined>(undefined);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState<string | null>(null);

  const openModal = (type: string) => {
    setModalType(type);
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    setTimeout(() => setModalType(null), 300);
  };

  const openQuote = (service?: string) => {
    setQuoteService(service);
    setQuoteOpen(true);
  };
  const closeQuote = () => {
    setQuoteOpen(false);
    setTimeout(() => setQuoteService(undefined), 300);
  };

  return (
    <div className="relative bg-background-950 min-h-screen">
      <Navbar onOpenQuote={openQuote} />

      <LanguageTransitionWrapper>
        <main>
          <HeroServiceDesk onOpenQuote={openQuote} />
          <DashboardSD />
          <FeaturesServiceDesk onOpenModal={openModal} />

          <InternalCTASection
            tag={t("sd.cta.tag")}
            title={t("sd.cta.title")}
            highlight="Openlab Secure"
            subtitle={t("sd.cta.subtitle")}
            buttonLabel={t("sd.cta.button")}
            homeButtonLabel={t("sd.cta.homeButton")}
            onQuote={() => openQuote("Service Desk")}
            image="https://readdy.ai/api/search-image?query=Friendly%20IT%20support%20agents%20smiling%20with%20headsets%20in%20a%20modern%20bright%20service%20desk%20with%20monitors%2C%20warm%20human%20atmosphere%2C%20professional%20editorial%20photography%2C%20human%20centered%2C%20soft%20depth%20of%20field&width=1600&height=900&seq=sd-cta-human-01&orientation=landscape"
          />
        </main>

        <LandingFooter pageName="Service Desk 24/7" />
      </LanguageTransitionWrapper>
      <QuoteModal isOpen={quoteOpen} onClose={closeQuote} preselectedService={quoteService} />
      <InfoModal
        isOpen={modalOpen}
        onClose={closeModal}
        modalType={modalType}
        onOpenQuote={(service) => {
          closeModal();
          openQuote(service);
        }}
      />
      <WhatsAppFloat />
    </div>
  );
}